import { render, staticRenderFns } from "./GenreView.vue?vue&type=template&id=2aac6fb8"
import script from "./GenreView.vue?vue&type=script&lang=js"
export * from "./GenreView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports